module.exports = __webpack_public_path__ + "static/media/avi.2c49d78e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/avi.svg
// module id = 595
// module chunks = 0